import { isUrlLang } from '@/i18n/languages'

/**
 * Every storefront route lives under a language prefix (`/pt/products/...`).
 * These helpers add and remove that prefix on internal paths.
 */

function isInternalPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\')
}

/** `/pt/cart?x=1` → `pt`; null when the first segment is not a language. */
export function getLangPrefix(path: string): string | null {
  const first = path.split(/[/?#]/)[1]
  return isUrlLang(first) ? first : null
}

/** `/pt/cart?x=1` → `/cart?x=1`; unprefixed paths pass through. */
export function stripLangPrefix(path: string): string {
  const lang = getLangPrefix(path)
  if (!lang) return path
  const rest = path.slice(lang.length + 1)
  return rest.startsWith('/') ? rest : `/${rest}`
}

/**
 * Prefixes an internal absolute path with `/${lang}`. External URLs, anchors,
 * relative paths and already-prefixed paths are returned unchanged.
 */
export function localizedPath(path: string, lang: string): string {
  if (!isInternalPath(path) || getLangPrefix(path)) return path
  return path === '/' ? `/${lang}` : `/${lang}${path}`
}

/** Same path in another language: `/pt/cart` → `/en/cart`. */
export function switchLangPrefix(path: string, lang: string): string {
  return localizedPath(stripLangPrefix(path), lang)
}
